import {useEffect, useState} from 'react';
import {Button, InputOTP, InputOTPGroup, InputOTPSlot} from '@continuum/ui';

interface OtpStepProps {
  email: string;
  isLoading: boolean;
  error: string | null;
  onSubmit: (code: string) => void;
  onResend: () => void;
}

export function OtpStep({
  email,
  isLoading,
  error,
  onSubmit,
  onResend,
}: OtpStepProps) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (error) {
      setValue('');
    }
  }, [error]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1 text-center">
        <h1 className="font-serif text-3xl text-foreground">
          Verification code
        </h1>
        <p className="text-sm text-muted-foreground">
          We sent a 6-digit code to {email}
        </p>
      </div>

      <div className="flex justify-center">
        <InputOTP
          maxLength={6}
          value={value}
          onChange={setValue}
          onComplete={() => {
            if (!isLoading) {
              onSubmit(value);
            }
          }}
          autoFocus
        >
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
            <InputOTPSlot index={3} />
            <InputOTPSlot index={4} />
            <InputOTPSlot index={5} />
          </InputOTPGroup>
        </InputOTP>
      </div>

      {error && <p className="text-center text-sm text-destructive">{error}</p>}

      <Button
        type="button"
        variant="default"
        size="fill"
        loading={isLoading}
        disabled={value.length < 6 || isLoading}
        onClick={() => onSubmit(value)}
      >
        Verify
      </Button>

      <p className="text-sm text-muted-foreground text-center">
        Didn&apos;t receive the code?{' '}
        <button
          type="button"
          className="text-foreground underline"
          onClick={onResend}
          disabled={isLoading}
        >
          Resend
        </button>
      </p>
    </div>
  );
}
